import { Modal, Select, Form, Checkbox, Input } from 'antd';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { useRef, useState } from 'react';

import BRButton from 'components/BRButton/BRButton';
import { notify } from 'components/Notify/Notify';

import './DeactivateStarsModal.less';

const { Option } = Select;

const DeactivateStarsModal = ({
  close,
  dropdownData,
  submitFunction,
  ...rest
}) => {
  const intl = useIntl();
  const formRef = useRef();

  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);
  const [isBlocking, setIsBlocking] = useState(false);

  const renderedOptions = dropdownData?.map((option, index) => (
    <Option key={index} value={option?.value}>
      {option?.label}
    </Option>
  ));

  const handleConfirm = async (values) => {
    const { deactivationReason, isBlocking, blockingReason } = values || {};
    let isBlockingFlag = isBlocking || undefined;
    try {
      setLoading(true);
      await submitFunction(
        deactivationReason?.value,
        isBlockingFlag,
        blockingReason
      );
    } catch (error) {
      notify(error.message);
    } finally {
      close();
      setLoading(false);
    }
  };
  return (
    <Modal
      className={'br-deactivate-star__modal-container'}
      closable={true}
      onCancel={close}
      maskClosable={true}
      {...rest}
      title={intl.formatMessage({
        id: 'stars.star_details.actions.deactivate_star'
      })}
      footer={
        <div className="br-dropdown-modal_footer">
          <BRButton
            form="deactivateStar"
            htmlType="submit"
            className="br-deactivate-modal__submit-btn"
            type="destructive-primary"
            disabled={!selected}
            loading={loading}
            label={intl.formatMessage({
              id: `stars.star_details.actions.${
                isBlocking ? 'deactivate_and_block' : 'deactivate'
              }`
            })}
          />
        </div>
      }
    >
      <Form onFinish={handleConfirm} name="deactivateStar" ref={formRef}>
        <Form.Item
          label={intl.formatMessage({
            id: 'stars.star_details.actions.deactivation_reason_label'
          })}
          name="deactivationReason"
        >
          <Select
            labelInValue
            showSearch
            size="large"
            className="br-deactivation-modal__deactivation-reasons"
            placeholder={intl.formatMessage({
              id: `dropdown_modal.placeholder`
            })}
            value={selected}
            optionFilterProp="children"
            loading={loading}
            disabled={loading}
            onSelect={setSelected}
            filterOption={(input, { children }) =>
              children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {renderedOptions}
          </Select>
        </Form.Item>
        <Form.Item
          name="isBlocking"
          valuePropName="checked"
          className={classNames('br-deactivation-modal__is-blocking-checkbox', {
            'br-deactivation-modal__is-blocking-checkbox-clicked': isBlocking
          })}
        >
          <Checkbox
            checked={isBlocking}
            onChange={(e) => {
              setIsBlocking(e.target.checked);
            }}
          >
            <span className="label_sm">
              {intl.formatMessage({
                id: 'stars.star_details.actions.block_title'
              })}
            </span>
          </Checkbox>
        </Form.Item>
        {isBlocking && (
          <Form.Item
            label={intl.formatMessage({
              id: 'stars.star_details.actions.block_reason'
            })}
            rules={[{ required: true }]}
            name="blockingReason"
            className="br-deactivation-modal__blocking-reason"
          >
            <Input
              placeholder={intl.formatMessage({
                id: 'stars.star_details.actions.blocking_placeholder'
              })}
            ></Input>
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
};
export default DeactivateStarsModal;
